/* **************************************************** Finishing Shedule Brand */
export interface FsManufacturer {
    id: number;
    category: string;
    sub_category: string | null;
    manufacture_name: string;
    created_by: number | null;
}

export const mapFsManufacturer = (data: any): FsManufacturer => {
    if (!data) {
        throw new Error("Invalid Data");
    }

    const res: FsManufacturer = {
        id: data.id,
        category: data.category,
        sub_category: data.sub_category || null,
        manufacture_name: data.manufacture_name,
        created_by: data.created_by || null,
    };

    return res;
};

export const mapFsManufacturers = (data: any[]): FsManufacturer[] => {
    if (!Array.isArray(data)) {
        throw new Error("Invalid Data");
    }

    return data.map(mapFsManufacturer);
};
